import { getIntrinsicElementProps, slot } from "@fluentui/react-utilities";
import * as React from 'react';

import { PageTitle } from "@tdp/common/pageTitle";

import { FormLayoutState, FormLayoutProps } from "./FormLayout.types";

export function useFormLayoutState_unstable(props: FormLayoutProps, ref: React.Ref<HTMLDivElement>): FormLayoutState {
  const {
    header,
    main,
    form,
    footer,
  } = props;
  const root = slot.always(
    getIntrinsicElementProps('div', {
      ...props,
      ref
    }),
    { elementType: 'div' });

  // top level sections
  const mainShortHand = slot.always(main, { elementType: 'main' });
  const footerShortHand = slot.always(footer, { elementType: 'menu' });

  // main content
  const headerShortHand = slot.always(header, { elementType: PageTitle });
  const formShortHand = slot.always(form, { elementType: 'form' })

  return {
    components: {
      root: 'div',
      main: 'main',
      header: PageTitle,
      footer: 'menu',
      form: 'form',
    },
    root: root,
    main: mainShortHand,
    header: headerShortHand,
    form: formShortHand,
    footer: footerShortHand,
  }
}
